var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM7.14583 10.7917C7.54854 10.7917 7.875 10.4652 7.875 10.0625C7.875 9.65979 7.54854 9.33333 7.14583 9.33333C6.74313 9.33333 6.41667 9.65979 6.41667 10.0625C6.41667 10.4652 6.74313 10.7917 7.14583 10.7917ZM7.14583 2.91667C6.74313 2.91667 6.41667 3.24313 6.41667 3.64583V8.02083C6.41667 8.42354 6.74313 8.75 7.14583 8.75C7.54854 8.75 7.875 8.42354 7.875 8.02083V3.64583C7.875 3.24313 7.54854 2.91667 7.14583 2.91667Z",
    fill: "#F31919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.00d3a4bcd3112918bc6642569daee3c0.svg";
export { ForwardRef as ReactComponent };